import { millisecondsToSeconds } from 'date-fns';

import { EpgProgram, RBProgram } from 'store/railsBuilder/reducer.types';
import { RecordingMetadata } from 'store/recordings/reducer.types';

import { VodEditorial } from 'services/data-manager/types';

import isTypeMatching from 'utils/isTypeMatching';

const getProgramTimes = (
    maybeProgrammeStartDate: string | number | undefined,
    maybeProgrammeEndDate: string | number | undefined,
) => {
    if (maybeProgrammeStartDate && maybeProgrammeEndDate) {
        if (
            isTypeMatching(maybeProgrammeStartDate, maybeProgrammeEndDate) &&
            typeof maybeProgrammeStartDate === 'string'
        ) {
            const programStartTime = millisecondsToSeconds(
                new Date(maybeProgrammeStartDate).getTime(),
            );
            const programEndTime = millisecondsToSeconds(
                new Date(maybeProgrammeEndDate).getTime(),
            );

            if (
                !Number.isNaN(programStartTime) &&
                !Number.isNaN(programEndTime)
            ) {
                return {
                    programStartTime,
                    programEndTime,
                };
            }
        }

        if (
            isTypeMatching(maybeProgrammeStartDate, maybeProgrammeEndDate) &&
            typeof maybeProgrammeStartDate === 'number'
        ) {
            return {
                programStartTime: maybeProgrammeStartDate,
                // @ts-ignore
                programEndTime: maybeProgrammeEndDate,
            };
        }
    }

    return {
        programStartTime: undefined,
        programEndTime: undefined,
    };
};

const getCorrectProgramStartAndEndTime = (
    item:
        | Partial<EpgProgram>
        | Partial<RBProgram>
        | Partial<VodEditorial>
        | Partial<RecordingMetadata>
        | undefined,
): {
    programStartTime: number | undefined;
    programEndTime: number | undefined;
} => {
    if (item) {
        if ('editorial' in item && item.editorial?.technicals?.[0]) {
            const { programStartTime, programEndTime } = getProgramTimes(
                item.editorial.technicals[0].ProgrammeStartDate,
                item.editorial.technicals[0].ProgrammeEndDate,
            );

            if (programStartTime && programEndTime) {
                return {
                    programStartTime,
                    // @ts-ignore
                    programEndTime,
                };
            }
        } else if ('technicals' in item) {
            const { programStartTime, programEndTime } = getProgramTimes(
                (item as VodEditorial)?.technicals?.[0]?.ProgrammeStartDate,
                (item as VodEditorial)?.technicals?.[0]?.ProgrammeEndDate,
            );

            if (programStartTime && programEndTime) {
                return {
                    programStartTime,
                    // @ts-ignore
                    programEndTime,
                };
            }
        }
    }

    return {
        programStartTime: item?.period?.start || undefined,
        programEndTime: item?.period?.end || undefined,
    };
};

export default getCorrectProgramStartAndEndTime;
